import { Checkbox, Col, Form, Table } from "antd";
import React from "react";

import SubHeading from "../../../../components/common/SubHeading";

import "./Notifications.css";

const notificationCheckBoxName = [
  { name: "isRentalApplicationReceived" },
  { name: "isOnlineLeasesReady" },
  { name: "assignedShowingUpdates" },
  { name: "isReceivedGuestCards" },
];

function Notifications({ heading, data }) {
  const columns = [
    {
      dataIndex: "event",
      title: "Event",
      key: "event",
    },
    {
      dataIndex: "email",
      title: "Email",
      key: "email",
      render: (email, record, index) =>
        email ? (
          <Form.Item key={index} name={record?.name} valuePropName="checked">
            <Checkbox></Checkbox>
          </Form.Item>
        ) : null,
    },
    {
      dataIndex: "mobilePush",
      title: "Mobile Push",
      key: "mobilePush",
      render: (mobilePush, record, index) =>
        mobilePush ? (
          <Form.Item
            key={index}
            name={`mobilePush${record?.name}`}
            valuePropName="checked"
          >
            <Checkbox></Checkbox>
          </Form.Item>
        ) : null,
    },
  ];
  return (
    <div className="notifications">
      <SubHeading subHeading={heading} />
      <Col span={24}>
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          rowKey={(record) => record.id}
        />
      </Col>
    </div>
  );
}

export default Notifications;
